<script>
	const rawHistory = `3 3 3 3 3 3 0 0 3 3 3 3 3 3
 			3 3 3 3 4 4 0 1 3 3 3 3 3 0
 			0 3 3 3 4 4 1 1 4 4 3 3 3 0
 			0 3 3 3 4 5 1 2 4 4 3 3 0 1
 			1 4 0 3 4 5 2 2 4 4 3 3 0 1
 			0 4 0 3 4 5 3 2 4 4 3 3 0 1
 			0 5 1 4 5 0 8 2 0 4 3 3 0 1
 			0 5 1 4 5 0 8 3 0 4 3 3 0 0
 			0 5 1 4 5 0 8 4 0 4 3 0 1 1
 			0 5 1 4 5 0 8 5 0 4 3 0 1 0
 			0 5 1 4 5 0 8 5 0 0 4 1 2 1
 			1 6 2 0 5 0 9 5 0 0 4 1 2 1 
 			0 6 2 0 5 0 10 5 0 0 4 1 2 1
 			1 7 3 1 0 0 11 5 0 0 4 1 2 1
 			0 7 3 1 0 0 12 5 0 0 4 1 2 1
 			1 0 3 1 0 0 13 5 1 1 5 2 3 1
 			1 0 3 1 0 0 13 6 1 1 5 2 3 0
 			1 0 3 1 0 1 13 7 1 1 5 2 0 1
 			0 0 3 1 0 1 14 7 1 1 5 2 0 1
 			1 1 0 1 0 1 15 7 1 1 5 2 0 1
 			0 1 0 1 0 1 16 7 1 1 5 2 0 1
 			0 1 0 0 0 1 22 7 1 1 0 2 0 1
 			0 1 0 0 0 1 22 8 1 1 0 2 0 0
 			0 1 0 0 0 1 22 8 0 2 0 2 0 0
 			1 0 0 0 0 1 22 8 0 2 0 2 0 0
 			1 0 0 0 0 0 22 10 0 2 0 0 1 0
 			0 0 0 0 0 0 23 10 0 2 0 0 1 0`;
	
	const historyLines = rawHistory.split('\n');
	export const gameHistory = historyLines.map(line => {
		const lineItems = line.trim().split(' ');
		const two = lineItems.slice(0, 6).map(a => parseInt(a, 10));
		const twoPot = parseInt(lineItems[6], 10);
		const onePot = parseInt(lineItems[7], 10);
		const one = lineItems.slice(8).map(a => parseInt(a, 10));
		
		return { one, two, onePot, twoPot };
	})
	
</script>